import { API_BASE_URL } from "../config/api";

async function handleResponse(res) {
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Error en la petición");
  }
  return res.json();
}

export async function fetchPackages() {
  const res = await fetch(`${API_BASE_URL}/packages`);
  return handleResponse(res);
}

export async function fetchDestinations() {
  const res = await fetch(`${API_BASE_URL}/destinations`);
  return handleResponse(res);
}

export async function fetchPackage(id) {
  const res = await fetch(`${API_BASE_URL}/packages/${id}`);
  return handleResponse(res);
}

export async function postComment(packageId, payload) {
  const res = await fetch(`${API_BASE_URL}/packages/${packageId}/comments`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function initWebpay(payload) {
  const res = await fetch(`${API_BASE_URL}/payments/webpay/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function confirmWebpay(token_ws) {
  const res = await fetch(`${API_BASE_URL}/payments/webpay/confirm`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token_ws }),
  });
  return handleResponse(res);
}

export async function fetchDepartures(packageId) {
  const res = await fetch(`${API_BASE_URL}/packages/${packageId}/departures`);
  return handleResponse(res);
}

export async function fetchExtras(packageId, departureId) {
  const url = departureId
    ? `${API_BASE_URL}/packages/${packageId}/extras?departure_id=${departureId}`
    : `${API_BASE_URL}/packages/${packageId}/extras`;
  const res = await fetch(url);
  return handleResponse(res);
}

export async function createHold(departureId, payload) {
  const res = await fetch(`${API_BASE_URL}/departures/${departureId}/hold`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function postContact(payload) {
  // El buzón destino vive solo en el backend; el cliente nunca lo conoce.
  const res = await fetch(`${API_BASE_URL}/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function fetchPurchase(ref) {
  // ref es el buy_order (o token_ws): un secreto que solo posee el comprador.
  // No se usa el id secuencial para evitar enumeración (IDOR).
  const res = await fetch(`${API_BASE_URL}/payments/${encodeURIComponent(ref)}`);
  return handleResponse(res);
}
